import React, { Children, memo } from 'react';
import { motion } from 'framer-motion';
import { X } from 'lucide-react';
import { Section } from './ui/Section';
const failures = [{
  title: 'Cursos de productividad genéricos',
  desc: 'Te enseñan a gestionar el tiempo, no a eliminar el trabajo.'
}, {
  title: 'Delegar en humanos prematuramente',
  desc: 'Hacerlo antes de tener procesos solo digitaliza el caos y aumenta tus costos fijos.'
}, {
  title: "Software 'All-in-one' corporativo",
  desc: 'Demasiado complejo, caro y requiere meses de aprendizaje que no tenés.'
}, {
  title: 'Confiar en tu memoria',
  desc: 'El seguimiento manual de leads hace que pierdas el 40% de tus ventas por puro cansancio.'
}];
const containerVariants = {
  hidden: {
    opacity: 0
  },
  visible: {
    opacity: 1,
    transition: {
      staggerChildren: 0.2
    }
  }
};
const itemVariants = {
  hidden: {
    opacity: 0,
    x: -20
  },
  visible: {
    opacity: 1,
    x: 0,
    transition: {
      duration: 0.5
    }
  }
};
export function FailedSolutions() {
  return <Section className="px-6 md:px-12 max-w-4xl mx-auto" data-id="element-28">
      <div className="mb-12" data-id="element-29">
        <span className="font-mono text-[#d4a853] text-sm tracking-widest uppercase mb-4 block" data-id="element-30">
          01 // El Diagnóstico
        </span>
        <h2 className="font-serif text-3xl md:text-4xl font-semibold text-gray-100" data-id="element-31">
          Por qué lo que intentaste no funcionó
        </h2>
      </div>

      <motion.div variants={containerVariants} initial="hidden" whileInView="visible" viewport={{
      once: true,
      margin: '-50px'
    }} className="grid gap-6" data-id="element-32">
        {failures.map((item, i) => <motion.div key={i} variants={itemVariants} className="flex items-start space-x-4 p-6 border border-gray-800 bg-[#0a0a0a] hover:border-[#b8860b]/30 transition-colors duration-300" data-id="element-33">
            <div className="mt-1 flex-shrink-0" data-id="element-34">
              <X className="w-6 h-6 text-red-900/80" strokeWidth={2} data-id="element-35" />
            </div>
            <div data-id="element-36">
              <h3 className="font-serif text-xl text-gray-200 mb-2" data-id="element-37">
                {item.title}
              </h3>
              <p className="font-sans text-gray-400 leading-relaxed" data-id="element-38">
                {item.desc}
              </p>
            </div>
          </motion.div>)}
      </motion.div>
    </Section>;
}